import { ApiResult, post } from '@/utils/api';
import { ResultModel } from '@/model/viewModel';
import { fetchShopKitchenList } from '@/service/base';
import {
  FoodOutListModel,
  FoodOutDetailsListModel,
  FoodOutListQueryModel,
  KitchenDutyBatchResultModel,
  KitchenDutyModel,
  KitchenOrderQueueItemModel,
  KitchenQueueQueryModel,
  KitchenStatusChangeModel,
  KitchenStatusResultModel,
  KitchenStoveModel,
  KitchenStoveStatusChangeModel,
  KitchenStoveStatusResultModel,
  KitchenUserModel,
  OrderOutStoveItemModel,
  OrderKitchenTasksQueryModel,
} from '@/model/kitchen';

export const fetchKitchenChefName = async (shopId: number, kitchenId: number): Promise<string> => {
  const response = await fetchShopKitchenList({
    pageNum: 1,
    pageSize: 999,
    data: { shopId, kitchenId, status: 0 },
  });
  if (response.code !== 200) throw new Error(response.msg || '暂时无法读取厨房信息，请刷新重试');
  const kitchen = response.result?.list?.find(
    (item) => Number(item.shopId) === shopId && Number(item.kitchenId) === kitchenId,
  );
  return kitchen?.kitchenContactName?.trim() || '';
};

export const fetchStoveList = (
  data: any,
): Promise<ApiResult<ResultModel<OrderOutStoveItemModel>>> =>
  post<ResultModel<OrderOutStoveItemModel>>('/order/out/selectStove', data);

export const fetchSumFood = (data: any): Promise<ApiResult<any>> =>
  post<any>('/order/out/sumFood', data);

export const fetchFoodOutList = (
  data: FoodOutListQueryModel,
): Promise<ApiResult<ResultModel<FoodOutListModel>>> =>
  post<ResultModel<FoodOutListModel>>('/order/out/selectFood', data);

export const changeKitchenStatus = (
  data: KitchenStatusChangeModel,
): Promise<ApiResult<KitchenStatusResultModel>> =>
  post<KitchenStatusResultModel>('/order/out/changeKitchenStatus', data);

export const fetchKitchenQueue = (
  data: KitchenQueueQueryModel,
): Promise<ApiResult<ResultModel<KitchenOrderQueueItemModel>>> =>
  post<ResultModel<KitchenOrderQueueItemModel>>('/order/out/selectOrder', data);

export const fetchOrderKitchenTasks = (
  data: OrderKitchenTasksQueryModel,
): Promise<ApiResult<ResultModel<FoodOutDetailsListModel>>> =>
  post<ResultModel<FoodOutDetailsListModel>>('/order/out/select', data);

export const fetchConfiguredStoves = (
  kitchenId: number,
): Promise<ApiResult<ResultModel<KitchenStoveModel>>> =>
  post<ResultModel<KitchenStoveModel>>('/dim/stove/select', {
    pageNum: 1,
    pageSize: 999,
    data: { kitchenId },
  });

export const changeStoveStatus = (
  data: KitchenStoveStatusChangeModel,
): Promise<ApiResult<KitchenStoveStatusResultModel>> =>
  post<KitchenStoveStatusResultModel>('/dim/stove/forbid', data);

export const fetchKitchenUserList = (
  data: any,
): Promise<ApiResult<ResultModel<KitchenUserModel>>> =>
  post<ResultModel<KitchenUserModel>>('/kitchen/user/select', data);

export const insertKitchenDutyBatch = (
  data: any,
): Promise<ApiResult<KitchenDutyBatchResultModel>> =>
  post<KitchenDutyBatchResultModel>('/kitchen/duty/insertBatch', data);

export const fetchKitchenDutyList = (
  data: any,
): Promise<ApiResult<ResultModel<KitchenDutyModel>>> =>
  post<ResultModel<KitchenDutyModel>>('/kitchen/duty/select', data);
